/**
 * Fetches Shopify's native product recommendations (related or
 * complementary) for the current product and injects the rendered markup.
 *
 * DOM contract: `data-url` points at routes.product_recommendations_url with
 * section_id/product_id/limit/intent already appended. Shopify's
 * recommendations endpoint re-renders this same section server-side with
 * `recommendations.performed` true; the response is scanned for the
 * `[data-recommendations]` element and its inner HTML replaces this
 * element's content. If Shopify returns zero recommendations, this element
 * removes itself so no empty heading is left behind.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.loadRecommendations();
  }

  async loadRecommendations() {
    const url = this.dataset.url;

    if (!url) {
      this.remove();
      return;
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        this.remove();
        return;
      }

      const text = await response.text();
      const doc = document.createElement('div');
      doc.innerHTML = text;

      const recommendations = doc.querySelector('[data-recommendations]');

      if (recommendations) {
        this.innerHTML = recommendations.outerHTML;
      } else {
        this.remove();
      }
    } catch (error) {
      this.remove();
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
